import { Loader } from 'google-maps'

Loader.KEY = 'AIzaSyAMhAAC9edgtq8cWggypEVLPBMM5En7EJE'
Loader.LIBRARIES = ['places']

export default Loader

export function youtubeSearchUrl (searchTerm, searchType, pageToken) {
  const pageTokenParam = pageToken ? `&pageToken=${pageToken}` : ''
  return `https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=6${pageTokenParam}&q=${searchTerm}&type=${searchType}&key=AIzaSyAMhAAC9edgtq8cWggypEVLPBMM5En7EJE`
}

export function validYouTubeUrl (url) {
  const rgx = /^(http(s)?:\/\/)?(www\.)?((youtube\.com\/watch\?v=)|(youtu.be\/))([a-zA-Z0-9\-_])+/
  return rgx.test(url)
}
